import React from 'react';
import styles from './AdminMobileStoreSearchList.module.css';
import FlexChild from 'layouts/flex/FlexChild';
import VerticalFlex from 'layouts/flex/VerticalFlex';
import AdminMobileEmptyMsg from './common/AdminMobileEmptyMsg';
import { mainBgColor, mainPadd2, pageCommonGap1, pageEH2FontSize, pageEH3FontSize, registerGap2, statDetailFontColor } from '../constraints/AdminConst';
import AdminMobileContentBox from './common/AdminMobileContentBox';
import HorizontalFlex from 'layouts/flex/HorizontalFlex';
import P from 'components/P';
import favStar from 'routes/adminMobile/images/favStar.png';

const AdminMobileStoreSearchList = ({stores, toggleFavorite}) => {
    if (!stores || stores.length === 0) {
        return (
            <VerticalFlex>
                <FlexChild padding={mainPadd2}>
                    <AdminMobileEmptyMsg />
                </FlexChild>
            </VerticalFlex>
        );
    }

    // 전화 걸기 버튼 클릭 이벤트 핸들러
    const handleCallButtonClick = () => {
        // 전화 걸기 기능 구현
        window.location.href = `tel:${stores.storePhoneNumber}`;
    };

    return (
        <VerticalFlex gap={pageCommonGap1} backgroundColor={mainBgColor} padding={mainPadd2}>
            {/* 반복 구간 */}
            {stores && stores.map((store, index) => (
                <FlexChild key={index} height="initial">
                    <AdminMobileContentBox flexStart>
                        <VerticalFlex gap={registerGap2}>
                            <FlexChild alignItems="flex-start">
                                <HorizontalFlex gap={registerGap2}>
                                    <FlexChild width="auto">
                                        <P size={pageEH2FontSize}>
                                            {store.storeName ? store.storeName : "점포명 없음"}
                                        </P>
                                    </FlexChild>
                                    <FlexChild width="auto">
                                        {/* 즐겨찾기 버튼 */}
                                        <div
                                            className={`${styles.favBtn} ${store.storeFav ? styles.favorite : ''}`}
                                            onClick={() => toggleFavorite(index)}
                                        >
                                            <img className={styles.favIcon} src={favStar} alt='즐겨찾기 아이콘' />
                                        </div>
                                    </FlexChild>
                                    <FlexChild>
                                        <HorizontalFlex gap={registerGap2} justifyContent="flex-end">
                                            <FlexChild width="auto">
                                                <div className={styles.infoBtn}>
                                                    <P size={pageEH3FontSize}>정보보기</P>
                                                </div>
                                            </FlexChild>
                                            <FlexChild width="auto">
                                                <div className={styles.callBtn} onClick={handleCallButtonClick}>
                                                    <P size={pageEH3FontSize}>전화연결</P>
                                                </div>
                                            </FlexChild>
                                        </HorizontalFlex>
                                    </FlexChild>
                                </HorizontalFlex>
                            </FlexChild>
                            <FlexChild>
                                <VerticalFlex gap={registerGap2}>
                                    <FlexChild alignItems="flex-start">
                                        <P size={pageEH3FontSize} color={statDetailFontColor}>
                                            {store.storeAddress ? store.storeAddress : "주소 없음"}
                                        </P>
                                    </FlexChild>
                                    <FlexChild alignItems="flex-start">
                                        <P size={pageEH3FontSize} color={statDetailFontColor}>
                                            {store.storeOpenData ? store.storeOpenData : "개점일 없음"} 개업
                                        </P>
                                    </FlexChild>
                                </VerticalFlex>
                            </FlexChild>
                        </VerticalFlex>
                    </AdminMobileContentBox>
                </FlexChild>
            ))}
            {/* 반복 구간 */}
        </VerticalFlex>
    );
};

export default AdminMobileStoreSearchList;